export const fileRejectionReason = {
    FileType: "fileType",
    FileSize: "fileSize",
};
//# sourceMappingURL=FileUpload.types.js.map